export function drawShipmentSections(pdf, startY, sections) {
  let y = startY;
  const rowHeight = 16;
  const sectionGap = 20;
  const leftMargin = 40;
  const sectionWidth = pdf.internal.pageSize.getWidth() - leftMargin * 2;

  pdf.setFont("helvetica", "normal");
  pdf.setFontSize(10);

  sections.forEach(({ title, lines }) => {
    // fondo sombreado para título
    pdf.setFillColor(180, 180, 180);
    pdf.rect(leftMargin, y, sectionWidth, rowHeight, "F");
    pdf.setTextColor(0);
    pdf.setFont("helvetica", "bold");
    pdf.text(title, leftMargin + 5, y + 12);

    y += rowHeight + 15;
    pdf.setFont("helvetica", "normal");

    lines.forEach((line) => {
      pdf.text(line, leftMargin + 5, y);
      y += rowHeight;
    });

    y += sectionGap;
  });

  return y;
}
